import {
  CircleLeftForgetIcon,
  CircleRightForgetIcon,
  ForgetRequstIcon,
} from 'common/Icons';
import { useTranslation } from 'react-i18next';
import FormForgetRequst from './components/FormForgetRequst';

function MobileRequest() {
  const { t } = useTranslation();

  return (
    <div className="bg-L-gray-50 dark:bg-D-gray-50 h-[100vh] inset-0 relative grid grid-rows-min-one">
      <div className="p-4">
        <div className="mt-4 mx-auto text-center">
          <ForgetRequstIcon className="inline-block" />
        </div>

        <div className="absolute top-0 right-0">
          <CircleRightForgetIcon />
        </div>
        <h5 className="text-5xl text-L-gray-400 my-4 text-center">
          {t(`FormSide.ForgetPasswordText`)}
        </h5>
        <div className="absolute left-0 top-[82px]">
          <CircleLeftForgetIcon />
        </div>
        <FormForgetRequst />
      </div>
    </div>
  );
}

export default MobileRequest;
